import React from "react";
import { useTheme } from "styled-components";

import { Icon, style } from "./Symbolicons";

const BagMoney = (props: Icon): React.ReactElement => {
  const theme = useTheme();
  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4c.486 0 .797.497.615.925l-.043.085-1.658 2.762.18.119c2.58 1.734 4.662 4.558 4.886 7.066l.017.258.003.183c0 3.322-1.826 4.435-5.91 4.584l-.57.015-.473.003h-2.095c-3.302 0-5.127-.406-6.158-1.832l-.127-.19-.013-.01a.6.6 0 01-.15-.223l-.028-.094v-.008l-.02-.038c-.242-.49-.388-1.055-.437-1.696l-.015-.28L4 15.398C4 12.81 6.137 9.781 8.835 7.94l.251-.167L7.428 5.01a.667.667 0 01.404-.99l.092-.016L8 4h8zm-2.078 4.668h-3.844l-.079.08-.087.073-.091.065c-2.478 1.598-4.488 4.37-4.488 6.512 0 .63.1 1.141.288 1.554l.086.17.055.093c.564.909 1.692 1.312 3.816 1.42l.577.022.306.006.491.004h2.095c.291 0 .569-.004.834-.01l.512-.02.244-.014.463-.035c2.606-.242 3.567-1.087 3.567-3.19 0-2.141-2.01-4.914-4.487-6.513a1.31 1.31 0 01-.258-.217zM9.177 5.333h5.645L13.77 7.088l-.065.121-.05.124h-3.31a1.343 1.343 0 00-.115-.245L9.177 5.333z"
        fill={props.color || theme.palette.grey600}
      />
    </svg>
  );
};

export { BagMoney };
